export const currentInvoice = (state) => state.currentInvoice
export const currentRecurrentInvoice = (state) => state.currentRecurrentInvoice
export const invoices = (state) => state.invoices
export const recurringInvoices = (state) => state.recurringInvoices
export const invoiceStatus = (state) => state.invoiceStatus
export const recurringInvoiceStatus = (state) => state.invoiceRecurringStatus
export const recurringInvoiceFrequency = (state) => state.recurringInvoiceFrequency


